export const setFixedPointerPosition = (
    pointerPosition: { x: number; y: number },
    dimension: "x" | "y",
    elementSize: number
) =>
    pointerPosition[dimension] > elementSize || pointerPosition[dimension] < 0
        ? elementSize / 2
        : +pointerPosition[dimension].toFixed(0);
